import { useToggle } from "react-use"
import cn from "classnames"
import { useAtom } from "@reatom/npm-react"
import { KeyboardEvent } from "react"

import { Choices, SurveyMultiAnswerValue } from "modules/NewClientSurvey/common"
import { answersAtom } from "modules/NewClientSurvey/common/models"
import style from "modules/NewClientSurvey/components/MultiSelect/components/List/style.module.scss"
import { Icon } from "components"
import { Checkbox, Text } from "ui-kit/components-branded/index"

const SHOW_MORE_LENGTH = 4

interface Props {
    className?: string
    questionId: string
    title?: string
    choices: Choices[]
    onClickItem: (choice: Choices) => void
}

export function List({ className, questionId, title, choices, onClickItem }: Props) {
    const [answers] = useAtom(answersAtom)
    const [showMore, toggleShowMore] = useToggle(false)

    const list = showMore ? choices : choices.slice(0, SHOW_MORE_LENGTH)

    function handleOnKeyUp(e: KeyboardEvent<HTMLDivElement>, choice: Choices) {
        if (e.key === "Enter") {
            onClickItem(choice)
        }
    }

    return (
        <div className={className}>
            <div className={style.list}>
                {title && <Text className={style.title}>{title}</Text>}
                {list.map((item) => {
                    const value = answers[questionId]?.value as SurveyMultiAnswerValue
                    return (
                        <Checkbox
                            className={cn("box", style.item)}
                            onChange={() => onClickItem(item)}
                            key={item.id}
                            checked={!!value?.[item.id]?.value === true}
                            onKeyUp={(e) => handleOnKeyUp(e, item)}
                        >
                            <div className={style.content}>
                                {item.title}
                                {item.comment && (
                                    <div className={style.comment}>{item.comment}</div>
                                )}
                            </div>
                        </Checkbox>
                    )
                })}
            </div>
            {choices.length > SHOW_MORE_LENGTH && (
                <Text className={style.more} onClick={toggleShowMore}>
                    {showMore ? (
                        <>
                            Свернуть <Icon type="arrow-up" size={24} />
                        </>
                    ) : (
                        <>
                            <div>Еще {choices.length - SHOW_MORE_LENGTH}</div>{" "}
                            <Icon type="arrow-down" size={24} />
                        </>
                    )}
                </Text>
            )}
        </div>
    )
}
